!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@campfire/titular-tooltip"), require("@material-ui/core"), require("@material-ui/icons/Add"), require("@material-ui/styles"), require("react"), require("react-dropzone"), require("uuid"), require("@campfire/hover-link"), require("@material-ui/icons/Clear"), require("@material-ui/icons/Description")) : "function" == typeof define && define.amd ? define(["exports", "@campfire/titular-tooltip", "@material-ui/core", "@material-ui/icons/Add", "@material-ui/styles", "react", "react-dropzone", "uuid", "@campfire/hover-link", "@material-ui/icons/Clear", "@material-ui/icons/Description"], t) : t((e = e || self)["file-upload-gallery"] = {}, e.titularTooltip, e.core, e.Add, e.styles, e.React, e.reactDropzone, e.uuid, e.hoverLink, e.ClearIcon, e.DescriptionIcon);
}(this, function (e, t, r, n, o, a, i, l, c, u, m) {
  "use strict";

  n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
  var s = "default" in a ? a.default : a;
  u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u, m = m && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;

  var _d = function d() {
    return (_d = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  };

  function f(e, t, r, n) {
    return new (r || (r = Promise))(function (o, a) {
      function i(e) {
        try {
          c(n.next(e));
        } catch (e) {
          a(e);
        }
      }

      function l(e) {
        try {
          c(n.throw(e));
        } catch (e) {
          a(e);
        }
      }

      function c(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
          e(t);
        })).then(i, l);
      }

      c((n = n.apply(e, t || [])).next());
    });
  }

  function p(e, t) {
    var r,
        n,
        o,
        a,
        i = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return a = {
      next: l(0),
      throw: l(1),
      return: l(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
      return this;
    }), a;

    function l(a) {
      return function (l) {
        return function (a) {
          if (r) throw new TypeError("Generator is already executing.");

          for (; i;) try {
            if (r = 1, n && (o = 2 & a[0] ? n.return : a[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, a[1])).done) return o;

            switch (n = 0, o && (a = [2 & a[0], o.value]), a[0]) {
              case 0:
              case 1:
                o = a;
                break;

              case 4:
                return i.label++, {
                  value: a[1],
                  done: !1
                };

              case 5:
                i.label++, n = a[1], a = [0];
                continue;

              case 7:
                a = i.ops.pop(), i.trys.pop();
                continue;

              default:
                if (!(o = (o = i.trys).length > 0 && o[o.length - 1]) && (6 === a[0] || 2 === a[0])) {
                  i = 0;
                  continue;
                }

                if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                  i.label = a[1];
                  break;
                }

                if (6 === a[0] && i.label < o[1]) {
                  i.label = o[1], o = a;
                  break;
                }

                if (o && i.label < o[2]) {
                  i.label = o[2], i.ops.push(a);
                  break;
                }

                o[2] && i.ops.pop(), i.trys.pop();
                continue;
            }

            a = t.call(e, i);
          } catch (e) {
            a = [6, e], n = 0;
          } finally {
            r = o = 0;
          }

          if (5 & a[0]) throw a[1];
          return {
            value: a[0] ? a[1] : void 0,
            done: !0
          };
        }([a, l]);
      };
    }
  }

  var g = o.makeStyles(function (e) {
    var t;
    return o.createStyles({
      dialogTitle: {
        backgroundColor: "#242424"
      },
      dialogContent: {
        backgroundColor: "#242424"
      },
      divider: {
        backgroundColor: "#424242"
      },
      titleText: {
        color: "#ffffff"
      },
      fileSizeText: {
        color: "#d2d2d2",
        marginLeft: 12
      },
      closeDialogIconButton: {
        border: "1px solid #ffffff"
      },
      image: (t = {
        display: "block",
        maxWidth: 1280,
        height: "auto",
        maxHeight: 720
      }, t[e.breakpoints.down("lg")] = {
        maxWidth: "100%",
        height: "auto",
        maxHeight: "100%"
      }, t)
    });
  }),
      h = a.memo(function (e) {
    var t,
        n = e.imagePreviewFile,
        o = e.onClose,
        a = e.open,
        i = g();
    return s.createElement(r.Dialog, {
      fullScreen: !0,
      open: a
    }, s.createElement(s.Fragment, null, s.createElement(r.DialogTitle, {
      className: i.dialogTitle
    }, s.createElement(r.Box, {
      display: "flex",
      justifyContent: "space-between",
      width: 1,
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(r.Box, null, s.createElement(r.Typography, {
      className: i.titleText,
      variant: "body1"
    }, n.name), s.createElement(r.Box, {
      display: "flex"
    }, s.createElement(c.HoverLink, {
      external: !0,
      color: "primary",
      hoverColor: "primary",
      to: (null === (t = n.campfireResource) || void 0 === t ? void 0 : t.url) || "",
      target: "_blank",
      rel: "noopener noreferrer",
      download: n.name
    }, s.createElement(r.Typography, {
      variant: "body2"
    }, "Download Image")), s.createElement(r.Typography, {
      className: i.fileSizeText,
      variant: "body2"
    }, function (e, t, r) {
      void 0 === t && (t = !1), void 0 === r && (r = 1);
      var n = t ? 1e3 : 1024;
      if (Math.abs(e) < n) return e + " B";
      var o = t ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
          a = -1,
          i = Math.pow(10, r),
          l = e;

      do {
        l /= n, ++a;
      } while (Math.round(Math.abs(l) * i) / i >= n && a < o.length - 1);

      return l.toFixed(r) + " " + o[a];
    }(n.size, !0)))), s.createElement(r.IconButton, {
      className: i.closeDialogIconButton,
      onClick: o
    }, s.createElement(u, {
      className: i.titleText
    })))), s.createElement(r.Divider, {
      className: i.divider
    }), s.createElement(r.DialogContent, {
      className: i.dialogContent
    }, s.createElement(r.Box, {
      paddingY: 2,
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      height: "100%"
    }, s.createElement("img", {
      src: n.objectUrl,
      alt: "full-preview",
      className: i.image
    })))));
  }),
      y = o.makeStyles(function (e) {
    return o.createStyles({
      rootFileItemContainer: {
        position: "relative",
        "&:hover $downloadText": {
          color: e.palette.primary.main,
          backgroundColor: "red,"
        }
      },
      rootFileItem: {
        backgroundColor: "#ffffff",
        minHeight: 58,
        borderRadius: 8,
        border: "solid 1px rgba(0, 0, 0, 0.25)",
        "&:hover": {
          backgroundColor: "#fafafa",
          borderColor: "rgba(0, 0, 0, 0.54)"
        }
      },
      icon: {
        color: e.palette.action.disabled
      },
      fileName: {
        maxWidth: 200
      },
      downloadText: {
        color: e.palette.text.secondary,
        position: "absolute",
        bottom: 12,
        left: 60,
        maxWidth: 200,
        textDecoration: "none"
      },
      downloadLink: {
        color: "inherit",
        textDecoration: "none"
      },
      fileWarning: {
        color: e.palette.warning.dark,
        fontSize: "13px"
      }
    });
  }),
      b = o.makeStyles(function (e) {
    return o.createStyles({
      rootItem: {
        marginTop: 8,
        marginRight: 16,
        marginBottom: 8,
        marginLeft: 0,
        "&:hover": {
          cursor: "pointer"
        }
      },
      removeFileButton: {
        backgroundColor: "#242424",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: e.palette.error.main,
          color: "#ffffff"
        }
      }
    });
  }),
      x = a.memo(function (e) {
    var n = e.file,
        o = e.externalLink,
        a = y(),
        i = n.size / 1e6;
    return s.createElement(s.Fragment, null, s.createElement(t.TitularTooltip, {
      description: n.name,
      maxWidth: 720
    }, s.createElement(r.Box, {
      className: a.rootFileItemContainer
    }, s.createElement("a", {
      className: a.downloadLink,
      href: o || n.objectUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      download: o ? void 0 : n.name
    }, s.createElement(r.Box, {
      position: "relative",
      display: "flex",
      className: a.rootFileItem,
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(r.Box, {
      paddingLeft: 1,
      paddingRight: 2
    }, s.createElement(m, {
      className: a.icon,
      fontSize: "large"
    })), s.createElement(r.Box, {
      paddingRight: 2,
      marginTop: "-24px"
    }, s.createElement(r.Typography, {
      className: a.fileName,
      noWrap: !0,
      display: "block",
      variant: "body2"
    }, n.name)))), s.createElement("a", {
      className: a.downloadText,
      href: n.objectUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      download: n.name
    }, s.createElement(c.HoverText, {
      noWrap: !0,
      display: "inline",
      variant: "caption",
      style: {
        color: "inherit"
      },
      hoverColor: "primary"
    }, "Download")))), i > 15 && s.createElement(r.Box, {
      pt: "4px",
      pl: "4px"
    }, s.createElement(r.Typography, {
      className: a.fileWarning
    }, "File too large. 15MB limit")));
  }),
      v = a.memo(function (e) {
    var n = e.children,
        o = e.onRemoveClick,
        a = b();
    return s.createElement(r.Box, {
      className: a.rootItem
    }, s.createElement(r.Box, {
      position: "relative",
      height: "100%"
    }, n, s.createElement(t.TitularTooltip, {
      placement: "top",
      description: "Remove attachment",
      enterDelay: 500
    }, s.createElement(r.Box, {
      position: "absolute",
      top: -9,
      right: -9
    }, s.createElement(r.IconButton, {
      className: a.removeFileButton,
      size: "small",
      onClick: o
    }, s.createElement(u, {
      fontSize: "small",
      style: {
        fontSize: 12
      }
    }))))));
  }),
      E = a.memo(function (e) {
    var n = e.file,
        o = a.useState(!1),
        i = o[0],
        l = o[1];
    return s.createElement(s.Fragment, null, s.createElement(t.TitularTooltip, {
      description: n.name
    }, s.createElement(r.Box, {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      overflow: "hidden",
      height: "100%",
      bgcolor: "#f6f8f9",
      border: "solid 1px rgba(0, 0, 0, 0.25)",
      borderRadius: 8,
      minWidth: 58,
      justifyContent: "center",
      onClick: function onClick(e) {
        e.stopPropagation(), l(!0);
      }
    }, s.createElement("img", {
      src: n.objectUrl,
      alt: "thumbnail-preview",
      style: {
        display: "block",
        maxWidth: 200,
        height: "auto",
        maxHeight: 58
      }
    }))), s.createElement(h, {
      imagePreviewFile: n,
      onClose: function onClose() {
        return l(!1);
      },
      open: i
    }));
  }),
      B = o.makeStyles(function (e) {
    return o.createStyles({
      root: {
        position: "relative",
        outline: "none"
      },
      addFileButton: {
        outline: "none",
        border: "dashed 1px #323232",
        borderRadius: 8,
        "&:hover": {
          cursor: "pointer",
          borderColor: e.palette.primary.light
        },
        "&:hover $addFileButtonIcon": {
          color: e.palette.primary.main
        }
      },
      addFileButtonIcon: {
        fontSize: 16
      }
    });
  }),
      k = a.memo(function () {
    return s.createElement(r.Box, {
      style: {
        boxSizing: "border-box"
      },
      position: "absolute",
      width: 1,
      height: 1
    }, s.createElement(r.Box, {
      display: "flex",
      flex: "1 1 auto",
      width: 1,
      height: 1,
      bgcolor: "rgba(255,255,255,0.7)",
      borderRadius: 8,
      border: "dashed 2px mediumspringgreen",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(r.Typography, {
      variant: "body2",
      color: "textSecondary"
    }, "Drop file to attach")));
  }),
      w = a.memo(function (e) {
    var o = e.uploadedFiles,
        c = e.allowMultiple,
        u = e.handleFilesAdded,
        m = e.handleFileRemoved,
        g = e.viewOnly,
        h = e.id,
        y = a.useState([]),
        w = y[0],
        T = y[1],
        I = a.useMemo(function () {
      return c || !c && w.length <= 1;
    }, [c, w]),
        j = a.useCallback(function (e) {
      var t = e.map(function (e) {
        return Object.assign(e, {
          id: l.v4(),
          objectUrl: URL.createObjectURL(e)
        });
      });
      u && u(t), T(c ? function (e) {
        return e.concat(t);
      } : t);
    }, [T, u]);

    var F = function F(e) {
      return f(void 0, void 0, void 0, function () {
        return p(this, function (t) {
          return [2, Promise.all(e.map(function (e) {
            return function (e) {
              return f(this, void 0, void 0, function () {
                return p(this, function (t) {
                  switch (t.label) {
                    case 0:
                      return [4, fetch(e.url).then(function (e) {
                        return e.blob();
                      }).then(function (t) {
                        return new File([t], e.name, {
                          type: t.type
                        });
                      })];

                    case 1:
                      return [2, {
                        file: t.sent(),
                        originalUrl: e.url,
                        fileId: e.fileId
                      }];
                  }
                });
              });
            }(e);
          }))];
        });
      });
    };

    a.useEffect(function () {
      F(o).then(function (e) {
        if (e.length && I) {
          var t = e.map(function (e) {
            return Object.assign(e.file, {
              id: e.fileId,
              objectUrl: URL.createObjectURL(e.file),
              campfireResource: {
                fileId: e.fileId,
                url: e.originalUrl
              }
            });
          });
          T(t);
        }
      });
    }, [o]);
    var N = i.useDropzone({
      onDrop: I ? j : void 0,
      noClick: !0,
      accept: "image/*, .bz, .bz2, .csv, .doc, .docx, .gz, .json, .jsonld, .odp, .ods, .odt, .pdf, .ppt, .pptx, .rar, .rtf, .svg, .tar, .txt, .xls, .xlsx, .xml, .zip, .7z"
    }),
        S = N.getRootProps,
        R = N.getInputProps,
        z = N.isDragActive,
        D = N.open,
        L = b(),
        U = B();
    return g ? s.createElement(C, {
      isLoading: o.length !== w.length,
      files: w
    }) : s.createElement(s.Fragment, null, s.createElement("div", _d({}, S(), {
      className: U.root,
      id: h
    }), s.createElement("input", _d({}, R())), z && I ? s.createElement(k, null) : null, s.createElement(r.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, w.map(function (e, t) {
      var r = function r() {
        m && m(e), T(function (e) {
          return e.filter(function (e, r) {
            return r !== t;
          });
        });
      };

      return e.type.includes("image") ? s.createElement(v, {
        onRemoveClick: r,
        key: e.objectUrl
      }, s.createElement(E, {
        file: e
      })) : s.createElement(v, {
        key: e.objectUrl,
        onRemoveClick: r
      }, s.createElement(x, {
        file: e
      }));
    }), s.createElement(r.Box, {
      className: L.rootItem
    }, I ? s.createElement(t.TitularTooltip, {
      title: w.length > 0 ? "Add another attachment" : "Add an attachment",
      description: "Attach a File from Your Computer"
    }, s.createElement("button", {
      className: U.addFileButton,
      type: "button",
      onClick: D
    }, s.createElement(r.Box, {
      height: 58,
      minWidth: 58,
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      paddingX: 2
    }, s.createElement(n, {
      className: U.addFileButtonIcon
    }), s.createElement(r.Typography, {
      style: {
        paddingLeft: 12
      },
      variant: "body2",
      color: "textSecondary"
    }, "Attach a File from Your Computer")))) : null))));
  }),
      C = a.memo(function (e) {
    var t = e.files,
        n = e.isLoading,
        o = b();
    return s.createElement(r.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, t.length > 0 ? t.map(function (e) {
      return e.type.includes("image") ? s.createElement(r.Box, {
        key: e.objectUrl,
        className: o.rootItem
      }, s.createElement(E, {
        file: e
      })) : s.createElement(r.Box, {
        key: e.objectUrl,
        className: o.rootItem
      }, s.createElement(x, {
        file: e,
        externalLink: e.campfireResource ? e.campfireResource.url : void 0
      }));
    }) : n ? s.createElement(r.Box, {
      minHeight: 79,
      paddingX: 3,
      display: "flex",
      alignContent: "center",
      alignItems: "center"
    }, s.createElement(r.LinearProgress, {
      style: {
        width: 128,
        height: 3
      }
    })) : s.createElement(s.Fragment, null, "Nothing to show"));
  });
  e.FileUploadGallery = w, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});